module.exports = __webpack_public_path__ + "img/5.1.80e4fcb6.png";